<h2>Site User</h2>

<div class="button_row">
    <button mat-raised-button
            routerLink="/site-users">Back</button>

    <button *ngIf="user && !user.disabled"
            mat-raised-button
            color="warn"
            type="button"
            (click)="disableUser()">Disable User</button>

    <button *ngIf="user?.disabled"
            mat-raised-button
            color="warn"
            type="button"
            (click)="enableUser()">Enable User</button>

    <mat-spinner id="user_spinner" [diameter]="20" *ngIf="enablingOrDisabling"></mat-spinner>
</div>

<table>
    <tr>
        <td>Email:</td>
        <td>{{user.email}}</td>
    </tr>
    <tr>
        <td>First Name:</td>
        <td>{{user.firstName}}</td>
    </tr>
    <tr>
        <td>Last Name:</td>
        <td>{{user.lastName}}</td>
    </tr>
    <tr>
        <td>Birth Date:</td>
        <td>{{user.birthDate | date}}</td>
    </tr>
    <tr>
        <td>Gender:</td>
        <td>{{user.gender}}</td>
    </tr>
    <tr>
        <td>Race:</td>
        <td>{{userRace}}</td>
    </tr>
    <tr>
        <td>Ethnicity:</td>
        <td>{{user.ethnicity}}</td>
    </tr>
    <tr>
        <td>Created:</td>
        <td>{{user.created | date:'short'}}</td>
    </tr>
    <tr>
        <td>Updated:</td>
        <td>{{user.updated | date:'short'}}</td>
    </tr>
    <tr>
        <td>Disabled:</td>
        <td>{{user.disabled? (user.disabled | date:'short') : 'No'}}</td>
    </tr>
</table>

<br/>
<mat-spinner *ngIf="loading"></mat-spinner>
<div *ngIf="!loading && orders.length == 0">Orders: None</div>
<rr-order-info *ngFor="let order of orders" [order]="order"></rr-order-info>

<div class="bottom"></div>
